import BusinessLogicException from "exceptions/BusinessLogicException";
import { generateFileName } from "util/support";
import type { AbstractFileEntity } from "features/merchantPayouts/types";
import type { ActionHookArg } from "../Props";
import useActionHandler from "./useActionHandler";

const defaultRequestHandler = async (
    fileEntity: Pick<AbstractFileEntity, 'coreId' | 'MOR'>,
    fileName: string
) => new Response();

export default function usePreviewSettlementXLS<T extends AbstractFileEntity>({
    row,
    handler = defaultRequestHandler
}: ActionHookArg<
    T,
    typeof defaultRequestHandler
>) {
    const actionHandler = useActionHandler(row);

    return actionHandler(async () => {
        if (!row.coreId) {
            throw new BusinessLogicException("Invalid fileKey!", {});
        }

        const response = await handler(
            row,
            generateFileName({
                prefix: 'Preview Settlement',
                fileKey: row.fileKey ?? row.coreId.toString(),
                extension: 'xls'
            })
        );

        if (!response.ok) {
            throw new BusinessLogicException("Something went wrong while generating .XLS file", { response });
        }
    });
};
